import React, { FC, useState } from "react";
import ReplyIcon from "@mui/icons-material/Reply";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router-dom";

import "./ShareButton.scss";
import { useActions } from "../../hooks/useActions";
import { myVotedArtwork, votesArtwork } from "../../route-link";

type SetSharesCount = (param: number) => number;

interface ShareButtonProps {
  setSharesCount?: (param: number | SetSharesCount) => void;
  submitShare?: (param: string) => Promise<void>;
  refetch?: () => void;
  id?: string;
}

const ShareButton: FC<ShareButtonProps> = ({ submitShare, setSharesCount, refetch, id }) => {
  const [title, setTitle] = useState("Copy link");
  const { openModalLogin } = useActions();
  const token = localStorage.getItem("tokenKey");
  const routerLocation = useLocation();

  const getLocationHref = async (): Promise<void> => {
    let text = window.location.href;
    if (routerLocation.pathname.includes(myVotedArtwork)) {
      text = text.replace(myVotedArtwork, votesArtwork);
    }
    navigator.clipboard.writeText(text);
    setTitle("Copied");

    if (!token && submitShare) {
      openModalLogin();
      return;
    }

    if (submitShare && id && setSharesCount && refetch) {
      await submitShare(id);
      setSharesCount(prev => prev + 1);
      refetch();
    }
  };

  return (
    <Tooltip onOpen={() => setTitle("Copy link")} title={title}>
      <IconButton
        color="inherit"
        style={{ padding: 2 }}
        onClick={getLocationHref}
        className="share-button"
      >
        <ReplyIcon className="share-button__icon" style={{ width: 25, height: 25 }} />
      </IconButton>
    </Tooltip>
  );
};

export default ShareButton;
